var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChipFraming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: none;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e6e6e6;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: #000;\r\n        stroke-linecap: round;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 0.25px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IconChipFraming") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "LayerFraming"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.48 33.54 26.48 30.78 26.09 30.64 26.09 33.4 26.48 33.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.48 30.78 46.55 19.54 46.16 19.4 26.09 30.64 26.48 30.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "26.48 33.54 46.55 22.3 46.55 19.54 26.48 30.78 26.48 33.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.22 31.29 20.22 28.53 19.83 28.39 19.83 31.15 20.22 31.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.22 28.53 40.29 17.29 39.9 17.14 19.83 28.39 20.22 28.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "20.22 31.29 40.29 20.05 40.29 17.29 20.22 28.53 20.22 30.64 20.22 31.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 29.04 13.96 26.27 13.57 26.13 13.57 28.9 13.96 29.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 26.27 34.03 15.03 33.64 14.89 13.57 26.13 13.96 26.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "13.96 29.04 34.03 17.8 34.03 15.03 13.96 26.27 13.96 28.39 13.96 29.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.71 26.78 7.71 24.02 7.31 23.88 7.31 26.64 7.71 26.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.71 24.02 27.77 12.78 27.38 12.64 7.31 23.88 7.71 24.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "7.71 26.78 27.77 15.54 27.77 12.78 7.71 24.02 7.71 26.13 7.71 26.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.45 24.53 1.45 21.77 1.05 21.63 1.05 24.39 1.45 24.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.45 21.77 21.51 10.53 21.12 10.39 1.05 21.63 1.45 21.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1.45 24.53 21.51 13.29 21.51 10.53 1.45 21.77 1.45 23.88 1.45 24.53"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.48,
    y1: 30.78,
    x2: 26.09,
    y2: 30.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.09,
    y1: 30.64,
    x2: 26.09,
    y2: 33.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.09,
    y1: 33.4,
    x2: 26.48,
    y2: 33.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.48,
    y1: 33.54,
    x2: 26.48,
    y2: 30.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.55,
    y1: 19.54,
    x2: 46.55,
    y2: 22.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.16,
    y1: 19.4,
    x2: 46.55,
    y2: 19.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 26.48,
    y1: 30.78,
    x2: 46.55,
    y2: 19.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.16,
    y1: 19.4,
    x2: 26.09,
    y2: 30.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 46.55,
    y1: 22.3,
    x2: 26.48,
    y2: 33.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.22,
    y1: 28.53,
    x2: 19.83,
    y2: 28.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.83,
    y1: 28.39,
    x2: 19.83,
    y2: 31.15
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 19.83,
    y1: 31.15,
    x2: 20.22,
    y2: 31.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.22,
    y1: 31.29,
    x2: 20.22,
    y2: 28.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.29,
    y1: 17.29,
    x2: 40.29,
    y2: 20.05
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39.9,
    y1: 17.14,
    x2: 40.29,
    y2: 17.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 20.22,
    y1: 28.53,
    x2: 40.29,
    y2: 17.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 39.9,
    y1: 17.14,
    x2: 19.83,
    y2: 28.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 40.29,
    y1: 20.05,
    x2: 20.22,
    y2: 31.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.96,
    y1: 26.27,
    x2: 13.57,
    y2: 26.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.57,
    y1: 26.13,
    x2: 13.57,
    y2: 28.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.57,
    y1: 28.9,
    x2: 13.96,
    y2: 29.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.96,
    y1: 29.04,
    x2: 13.96,
    y2: 26.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.03,
    y1: 15.03,
    x2: 34.03,
    y2: 17.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.64,
    y1: 14.89,
    x2: 34.03,
    y2: 15.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 13.96,
    y1: 26.27,
    x2: 34.03,
    y2: 15.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33.64,
    y1: 14.89,
    x2: 13.57,
    y2: 26.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 34.03,
    y1: 17.8,
    x2: 13.96,
    y2: 29.04
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.7,
    y1: 24.02,
    x2: 7.31,
    y2: 23.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.31,
    y1: 23.88,
    x2: 7.31,
    y2: 26.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.31,
    y1: 26.64,
    x2: 7.7,
    y2: 26.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.7,
    y1: 26.78,
    x2: 7.7,
    y2: 24.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.77,
    y1: 12.78,
    x2: 27.77,
    y2: 15.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.38,
    y1: 12.64,
    x2: 27.77,
    y2: 12.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.7,
    y1: 24.02,
    x2: 27.77,
    y2: 12.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.38,
    y1: 12.64,
    x2: 7.31,
    y2: 23.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 27.77,
    y1: 15.54,
    x2: 7.7,
    y2: 26.78
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1.45,
    y1: 21.77,
    x2: 1.06,
    y2: 21.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1.06,
    y1: 21.63,
    x2: 1.06,
    y2: 24.39
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1.06,
    y1: 24.39,
    x2: 1.45,
    y2: 24.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1.45,
    y1: 24.53,
    x2: 1.45,
    y2: 21.77
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.51,
    y1: 10.53,
    x2: 21.51,
    y2: 13.29
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.12,
    y1: 10.39,
    x2: 21.51,
    y2: 10.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1.45,
    y1: 21.77,
    x2: 21.51,
    y2: 10.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.12,
    y1: 10.39,
    x2: 1.06,
    y2: 21.63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.51,
    y1: 13.29,
    x2: 1.45,
    y2: 24.53
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChipFraming);
export default __webpack_public_path__ + "static/media/IconChipFraming.4290014af964962932bbbb6e1eeff12b.svg";
export { ForwardRef as ReactComponent };